import React from 'react';
import { Table,Card, Breadcrumb } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import MainLayout from '@common/layouts/MainLayout/MainLayout';
import useDevicesTypeView from './useDevicesTypeView';

import styles from './DevicesTypeView.module.less';
import { Link } from 'react-router-dom';
  

function VariablesReviewStep4(props) {

  const { t } = useTranslation(); 
  const { loading, dataSource, columns, isEditDefault,
         deviceType } = useDevicesTypeView();


  return (
    <MainLayout applyWidthLimit>
    <div className={styles.wrapper}> 

      <Breadcrumb className={styles.date_wrapper}>
        <Breadcrumb.Item className={styles.breadcrumb}>
          <Link to="/dispositivos/tipo-dispositivo">{t('menu_items.main.device_types')}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.device_types_details')}</Breadcrumb.Item>
        <Breadcrumb.Item className={styles.breadcrumb}>{deviceType?.device_type_name || t('views.dynamic_device_types_create_edit.steps.device_type')}</Breadcrumb.Item>
      </Breadcrumb>

      <Card style={{ marginTop:10, marginBottom:20, width:'100%' , boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className="className"> 
          <p style={{fontSize:'16px',fontWeight:'bold',color:'#39587D'}}>
            <b>
            {t('views.dynamic_device_types_create_edit.steps.device_type')}
            </b>
          </p>

          <div className={styles.rowDeviceData}>
            <div className={styles.colDeviceData}>
              <p>
                <b>
                {t('views.dynamic_device_types_create_edit.labels.device_type_name')}
                </b>
              </p>
              <p>
                {deviceType?.device_type_name || ''}
              </p>
            </div>

            <div className={styles.colDeviceData}>
              <p>
                <b>
                {t('views.dynamic_device_types_create_edit.labels.device_type_description')}
                </b>
              </p>
              <p>
                {deviceType?.device_type_description || ''}
              </p>
            </div> 

            <div className={styles.colDeviceData}>
              <p>
                <b>
                {t('forms.users.labels.business_line')}
                </b>
              </p>
              <p>
                {deviceType?.business_type_name || ''}
              </p>
            </div> 
           
          </div>

          

      </Card>

      <Card>
        <Table 
            loading={loading}
            className={styles.table} 
            columns={columns}
            dataSource={dataSource} 
            pagination={false}
          />
      </Card>
    </div>

  </MainLayout>
  );

}

export default VariablesReviewStep4;
